import Icon from '@/components/snippets/icon/icon'
import { formatMoney } from '@/components/helpers/currency-formatter'
import { PRICE_FILTER_FIELD } from './FilterUtils'
import { globalState } from '@/components/helpers/utils'

export function FilterSelected({ activeFilters, onRemove, onClear }) {
  if (!activeFilters || activeFilters.size === 0) return null

  const formatFilterValue = (filter) => {
    const [field, value] = filter.split(':')
    if (field === PRICE_FILTER_FIELD) {
      const [min, max] = value.split('<->')
      const formatMin = parseFloat(min) % 1 === 0 ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals') : globalState.shopify.moneyFormat
      const formatMax = parseFloat(max) % 1 === 0 ? globalState.shopify.moneyFormat.replace('amount', 'amount_no_decimals') : globalState.shopify.moneyFormat
      return `${formatMoney(parseFloat(min) * 100, formatMin)} - ${formatMoney(parseFloat(max) * 100, formatMax)}`
    }
    return value
  }

  return (
    <div class="shrink-0 flex flex-wrap gap-0.5 lg:gap-y-0.875 lg-max:px-margin pt-1.25 pb-1.375 border-b border-neutral-medium">
      {[...activeFilters].map((filter) => {
        return (
          <btn class="shrink-0 btn btn-light btn-fill btn-xs text-xs font-medium gap-x-0.5" onClick={() => onRemove(filter)}>
            {formatFilterValue(filter)}
            <div className="flex size-[9px] children:size-full">
              <Icon id="close" />
            </div>
          </btn>
        )
      })}
      <btn class="shrink-0 btn btn-primary btn-text btn-xs text-xs font-medium" onClick={onClear} aria-label="Clear all filters">
        Clear all
      </btn>
    </div>
  )
}
